import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OriginVhost,
  OriginVhostCreate,
  OriginVhostPHPModule,
  OriginVhostPHPConfigParameter,
  OriginVhostUpdate,
  OriginVhostConfigUpdate,
} from '../models/origin-vhost.models';

@Injectable({
  providedIn: 'root',
})
export class OriginVhostService {
  private http = inject(HttpClient);

  searchVhosts(page?: number, search?: string): Observable<[OriginVhost[], number]> {
    let url = `/origin-vhost/vhosts?page=${page}`;
    if (search) url = `${url}&search=${search}`;

    return this.http.get<[OriginVhost[], number]>(url);
  }

  createVhost(data: OriginVhostCreate): Observable<void> {
    return this.http.post<void>('/origin-vhost/vhosts', data);
  }

  getPHPModules(): Observable<OriginVhostPHPModule[]> {
    return this.http.get<OriginVhostPHPModule[]>('/origin-vhost/php/modules');
  }

  getPHPConfigParameters(): Observable<OriginVhostPHPConfigParameter[]> {
    return this.http.get<OriginVhostPHPConfigParameter[]>('/origin-vhost/php/config-parameters');
  }

  updateVhost(id: number, data: OriginVhostUpdate): Observable<void> {
    return this.http.patch<void>(`/origin-vhost/vhosts/${id}`, data);
  }

  createPHPModule(name: string): Observable<OriginVhostPHPModule> {
    return this.http.post<OriginVhostPHPModule>('/origin-vhost/php/modules', { name });
  }

  deleteVhost(id: number): Observable<void> {
    return this.http.delete<void>(`/origin-vhost/vhosts/${id}`);
  }

  updatePHPConfig(id: number, config: OriginVhostConfigUpdate): Observable<void> {
    return this.http.patch<void>(`/origin-vhost/vhosts/${id}/php`, config);
  }

  deleteLog(id: number): Observable<void> {
    return this.http.delete<void>(`/origin-vhost/logs/${id}`);
  }

  getVhostByWebsiteId(websiteId: number): Observable<OriginVhost> {
    return this.http.get<OriginVhost>(`/origin-vhost/vhosts/websites/${websiteId}`);
  }

  createWildCard(id: number): Observable<void> {
    return this.http.patch<void>(`/origin-vhost/vhosts/${id}/wildcard`, {});
  }

  removeWildCard(id: number): Observable<void> {
    return this.http.patch<void>(`/origin-vhost/vhosts/${id}/wildcard?remove=true`, {});
  }
}
